// import { BidRequestFormValues } from "@/components/bid-request/types";
import { Textarea } from "@/components/ui/textarea";
import { Input } from "@/components/ui/input";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import React from "react";
import { UseFormReturn } from "react-hook-form";
import { BidFormValues } from "./types";

const DealerSpecialInstructions = ({
  form,
}: {
  form: UseFormReturn<BidFormValues>;
}) => {
  return (
    <>
      <FormField
        control={form.control}
        name="dealerSpecialInstructions"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Special Instructions for Dealers</FormLabel>
            <FormControl>
              <Textarea {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="setupTime"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Setup Time</FormLabel>
            <FormControl>
              <Input type="time" {...field} placeholder="HH:MM" />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="parkingInfo"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Parking Information</FormLabel>
            <FormControl>
              <Textarea
                {...field}
                placeholder="Parking details, restrictions, valet information, etc."
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
};

export default DealerSpecialInstructions;
